import { themes } from '@olist/design-system-tokens';
import { css } from 'styled-components';

const wrapContentWithSeparator = () => {
    return css `
    overflow: hidden;
    text-align: center;
    width: 100%;

    &:after,
    &:before {
      background-color: ${themes.olist.base.color.neutral.soft};
      content: '';
      display: inline-block;
      height: 1px;
      position: relative;
      vertical-align: middle;
      width: 50%;
    }

    &:after {
      margin-right: -50%;
      left: 9px;
    }

    &:before {
      right: 9px;
      margin-left: -50%;
    }
  `;
};

export { wrapContentWithSeparator };
